import {
  BugIcon,
  CircleAlertIcon,
  InfoIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { PropsWithChildren } from 'react';

import { cn } from '~/lib/utils/classname';

import Wrap from '../atoms/Wrap';

export interface Props extends PropsWithChildren {
  variant?: 'info' | 'debug' | 'warning' | 'error';
  showIcon?: boolean;
  className?: string;
}

const GenericFallbackIcon: React.FC<{ variant?: Props['variant'] }> = ({
  variant,
}) => {
  switch (variant) {
    case 'info':
      return <InfoIcon />;

    case 'debug':
      return <BugIcon />;

    case 'warning':
      return <TriangleAlertIcon />;

    case 'error':
      return <CircleAlertIcon />;
  }

  return null;
};

const GenericFallback: React.FC<Props> = ({
  variant = 'info',
  showIcon = false,
  className,
  children,
}) => (
  <div
    className={cn(
      'm-6 flex items-center justify-center rounded border px-6 py-6',
      {
        'border-cyan-200 bg-cyan-100 text-cyan-950': variant === 'info',
        'border-purple-200 bg-purple-100 text-purple-950': variant === 'debug',
        'border-amber-200 bg-amber-100 text-amber-950': variant === 'warning',
        'border-red-200 bg-red-100 text-red-950': variant === 'error',
      },
      className
    )}
  >
    <Wrap
      with={(children) => (
        <div className="flex items-center gap-x-2">
          <GenericFallbackIcon variant={variant} />
          <div>{children}</div>
        </div>
      )}
      when={showIcon}
    >
      {children}
    </Wrap>
  </div>
);

export default GenericFallback;
